import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

type CardProps = {
    children: React.ReactNode,
    onClick?: () => void,
    className?: string,
    style?: React.CSSProperties,
    pointer?: boolean,
};

Card.defaultProps = {
    onClick: () => {},
    className: '',
    style: {},
    pointer: false,
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    card: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.card,
        borderRadius: 12,
    },
    pointer: {
        cursor: 'pointer',
    },
}));

function Card(props: CardProps): React.ReactElement {
    const {
        children,
        onClick = Card.defaultProps.onClick,
        className,
        style = Card.defaultProps.style,
        pointer,
    } = props;
    const classes = useStyle();

    return (
        <div className={clsx(classes.card, { [classes.pointer]: pointer }, className)} style={style} onClick={onClick}>
            { children }
        </div>
    );
}

export { Card };
